import Link from 'next/link'
import addPostIcon from '../../assets/navbar/addDesign.svg'
import blogIcon from '../../assets/navbar/blog.svg'
import aiDesignIcon from '../../assets/navbar/design.svg'
import helpIcon from '../../assets/navbar/help.svg'
import aboutIcon from '../../assets/navbar/info.svg'
import exploreIcon from '../../assets/navbar/home.svg'
import termsIcon from '../../assets/navbar/security.svg'
import securityIcon from '../../assets/navbar/terms-and-conditions.svg'
import textLogoImg from '../../assets/text-logo.png'
import { getRoute, ROUTES } from '../../constants/navigation'
import GetAppButton from '../GetAppButton'
import { MobileModal } from '../MobileModal/MobileModal'
import { DMLogo, GetAppButtonWrapper, MenuLinkLine, MenuLinkName, MenuLinks, MobileDrawer } from './MobileDrawerMenu.styles'

const designYourRoomRoute = getRoute(ROUTES.HOMEPAGE)
const exploreRoute = getRoute(ROUTES.EXPLORE)
const blogRoute = getRoute(ROUTES.BLOG)
const helpCenterRoute = getRoute(ROUTES.HELP_CENTER)
const termsRoute = getRoute(ROUTES.STATIC_PAGES.TERMS)
const privacyPolicyRoute = getRoute(ROUTES.STATIC_PAGES.PRIVACY_POLICY)
const aboutRoute = getRoute(ROUTES.STATIC_PAGES.ABOUT)

export const MobileDrawerMenu = ({ onClose }) => {
  return (
    <MobileModal onClose={onClose} horizontal>
      <MobileDrawer>
        <DMLogo src={textLogoImg} alt="DecorMatters" />
        <GetAppButtonWrapper>
          <GetAppButton />
        </GetAppButtonWrapper>
        <MenuLinks>
          <Link href={designYourRoomRoute.path}>
            <MenuLinkLine onClick={onClose}>
              <img src={addPostIcon} alt="" />
              <MenuLinkName>Design Your Room</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <Link href="/ai-interior-design-app">
            <MenuLinkLine onClick={onClose}>
              <img src={aiDesignIcon} alt="" />
              <MenuLinkName>AI Design</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <Link href={exploreRoute.path}>
            <MenuLinkLine onClick={onClose}>
              <img src={exploreIcon} alt="" />
              <MenuLinkName>Explore</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <Link href={blogRoute.path}>
            <MenuLinkLine onClick={onClose}>
              <img src={blogIcon} alt="" />
              <MenuLinkName>Blog</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <Link href={helpCenterRoute.path}>
            <MenuLinkLine onClick={onClose}>
              <img src={helpIcon} alt="" />
              <MenuLinkName>Help Center</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <Link href={termsRoute.path}>
            <MenuLinkLine onClick={onClose}>
              <img src={termsIcon} alt="" />
              <MenuLinkName>Terms of Use</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <Link href={privacyPolicyRoute.path}>
            <MenuLinkLine onClick={onClose}>
              <img src={securityIcon} alt="" />
              <MenuLinkName>Privacy Policy</MenuLinkName>
            </MenuLinkLine>
          </Link>
          <a href={aboutRoute.path} {...aboutRoute.props} onClick={onClose}>
            <MenuLinkLine>
              <img src={aboutIcon} alt="" />
              <MenuLinkName>About</MenuLinkName>
            </MenuLinkLine>
          </a>
        </MenuLinks>
      </MobileDrawer>
    </MobileModal>
  )
}
